import { Deal } from '../types';
import { exportRowsToCsv, exportRowsToXlsx } from './tableExport';

const HEADERS = ['Deal', 'Deal Owners', 'Submitters'];

const joinNames = (partners: Deal['dealOwners']) =>
  (partners ?? []).map((p) => p.name).join(', ');

const buildRows = (deals: Deal[]): string[][] =>
  deals.map((deal) => [
    deal.name ?? '',
    joinNames(deal.dealOwners),
    joinNames(deal.operatingPartners),
  ]);

export const exportDealsToXlsx = (deals: Deal[]) =>
  exportRowsToXlsx({
    headers: HEADERS,
    rows: buildRows(deals),
    filename: 'Deals',
    sheetName: 'Deals',
  });

export const exportDealsToCsv = (deals: Deal[]) =>
  exportRowsToCsv({
    headers: HEADERS,
    rows: buildRows(deals),
    filename: 'Deals',
  });
